import { useEffect } from "react";
import Select from "react-select";
import { Controller } from "react-hook-form";

import { customErrorStyles, customStyles } from "./stylesData";

import innerStyles from "./innerSelectWithSearch.module.css";

function SelectWithSearch({
  inputProps,
  dataForm,
  control,
  externalStyles,
  setValue,
  mode,
  errors = {},
  clearErrors,
  isMulti = false,
}) {
  const getValueForSelectSearch = (value) => {
    if (Array.isArray(value)) {
      return value.map((val) => inputProps.options.find((item) => item.value === val));
    } else if (typeof value === "object" && value !== null) {
      return value;
    } else if (value == null) { // covers both null and undefined
      return null;
    } else {
      return inputProps.options.find((item) => item.value === value);
    }
  };
  

  useEffect(() => {
    setValue(inputProps.key, dataForm?.[inputProps.key]);
    if (!!dataForm?.[inputProps.key] && clearErrors) {
      clearErrors(inputProps.key);
    }
  }, [dataForm]);

  return (
    <div className={`${externalStyles?.container} ${innerStyles["container"]}`}>
      <label className={`${externalStyles?.label} ${innerStyles["label"]}`}>
        {inputProps.label}
        {inputProps.required && mode !== "view" && (
          <span className={innerStyles["red-dot"]}>*</span>
        )}
      </label>
      <Controller
        name={inputProps.key}
        control={control}
        rules={{
          required: inputProps.required && `Заполните поле`,
          validate: (value) => {
            if (inputProps.hasOwnProperty("customValidation")) {
              return inputProps.customValidation(value);
            }
          },
        }}
        render={({ field: { onChange, value } }) => (
          <Select
            noOptionsMessage={() => "Нет данных"}
            id={inputProps.key}
            isDisabled={inputProps.disabled || mode === "view"}
            isSearchable={inputProps.searchable}
            value={getValueForSelectSearch(value)}
            onChange={(newValue) => {
              if (isMulti) {
                setValue(
                  inputProps.key + "Name",
                  newValue ? newValue.map((item) => item.label).join(", ") : "",
                );
                onChange(newValue ? newValue.map((item) => item.value) : []);
              } else {
                setValue(inputProps.key + "Name", newValue.label);
                onChange(newValue.value);
              }
            }}
            isMulti={isMulti}
            placeholder="Выберите"
            options={inputProps.options}
            styles={errors[inputProps.key] ? customErrorStyles : customStyles}
          />
        )}
      />
      {errors[inputProps.key] && (
        <div className={innerStyles["error-text"]}>
          {errors[inputProps.key].message}
        </div>
      )}
    </div>
  );
}

export default SelectWithSearch;
